export default __webpack_public_path__ + "sounds/wrong3.mp3";